import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import UnitListService from './UnitListService';

class UnitDivisionFormDialogService {
  form = new FormService();
  submit = new FetchService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.form.validations = {
      name: [isRequired],
      module: [isRequired],
      type: [isRequired],
      group: [isRequired],
      order: [isRequired],
      scoreToPass: [isRequired],
      difficulty: [isRequired],
    };
  }

  open = action((moduleId, unitId) => {
    this.form.setInitialValues({});
    this.form.reset();
    this.isOpen = true;
    this.fetch
      .fetch({
        url: `/modules/${moduleId}/units/${unitId}`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.form.setInitialValues({
            id: this.fetch.data.id,
            module: this.fetch.data.module.id,
            course: this.fetch.data.module.course.id,
            type: this.fetch.data.type.id,
            scoreToPass: this.fetch.data.scoreToPass,
            difficulty: this.fetch.data.difficulty,
          });
        }
      });
  });

  handleDivide = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      return;
    }

    this.submit
      .fetch({
        url: `/modules/${this.form.getValue('module')}/units/${this.form.getValue('id')}/divide`,
        method: 'patch',
        body: {
          name: this.form.getValue('name'),
          order: this.form.getValue('order'),
          group: this.form.getValue('group'),
        },
      })
      .then(() => {
        if (this.submit.data) {
          this.isOpen = false;
          NotificationService.addNotification('Unit divided successfully.', 'success');
          UnitListService.load();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error dividing unit.', 'error');
        }
      });
  });

  handleCancel = action(() => {
    this.isOpen = false;
  });
}
const unitDivisionFormDialogService = new UnitDivisionFormDialogService();

export default unitDivisionFormDialogService;
